import { getUser } from "@store/visitWidgetApi";
import { getInitialPlanData } from "./getInitialPlanData";
import { PlanItem } from "@dto/PlanItem";
import { setPlanAction } from "@store/plan/planReducer";
import { AppDispatch } from "@store/store";
import { getPlan } from "@store/services/plan";

const initializeUser = async (accessToken: string, dispatch: AppDispatch) => {
  const user = await getUser();

  const planData = await getInitialPlanData(user);

  let planItems = [] as Array<PlanItem>;

  if (planData.planId) {
    dispatch(getPlan.initiate(Number(planData.planId), { forceRefetch: true }));
  }

  dispatch(setPlanAction({ plan: { id: Number(planData.planId) } } as any));
  return {
    planItems,
    user,
    accessToken,
  };
};

export { initializeUser };
